import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENV } from '@di-tokens';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private readonly http = inject(HttpClient);
  private readonly url = inject(ENV).remoteApi;

  get<T>(endpoint: string, payload?: any): Observable<T> {
    const params = new HttpParams({
      fromObject: payload ?? {},
    });
    return this.http.get<T>(`${this.url}/${endpoint}`, { params });
  }

  post<T>(endpoint: string, body: object): Observable<T> {
    return this.http.post<T>(`${this.url}/${endpoint}`, body);
  }

  put<T>(endpoint: string, body: object): Observable<T> {
    return this.http.put<T>(`${this.url}/${endpoint}`, body);
  }

  delete<T>(endpoint: string): Observable<T> {
    return this.http.delete<T>(`${this.url}/${endpoint}`);
  }

  patch<T>(endpoint: string, body: object): Observable<T> {
    return this.http.patch<T>(`${this.url}/${endpoint}`, body);
  }
}
